<mat-toolbar color="accent"
  >Test {{ isMarketingContext ? 'Marketing Step' : 'Automation' }}</mat-toolbar
>
<form [formGroup]="form">
  <mat-dialog-content class="!text-black">
    <div class="flex flex-col gap-4">
      <pr-information-box type="info">
        <div>
          <span>This will run the </span>
          <span>{{
            isMarketingContext ? 'marketing step ' : 'automation '
          }}</span>
          <span>immediately using the selected </span>
          <span *ngIf="organisation.hasMultiplePractices$ | async"
            >Practice and
          </span>
          <span>Patient.</span>
        </div>
      </pr-information-box>

      @if (organisation.hasMultiplePractices$ | async) {
        <pr-practice-selector
          subscriptSizing="dynamic"
          label="Select Practice to send the automation from"
          [brands]="[data.brand]"
          [practice]="data.practice"
          (practiceSelected)="form.controls.practice.setValue($event)"
        />
      }

      <pr-patient-selector
        subscriptSizing="dynamic"
        placeholder="Select Patient to {{
          isAutomatedNotification ? 'send' : 'add'
        }} the automation to"
        formControlName="patient"
      />

      @if (showResourceSelector()) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select {{ resourceName }}</mat-label>
          <mat-select formControlName="scopeOption">
            @for (option of scopeOptions(); track option.ref.path) {
              <mat-option [value]="option">
                {{ option.name }}
              </mat-option>
            } @empty {
              <mat-option disabled
                >Patient has no {{ resourceName }}s</mat-option
              >
            }
          </mat-select>
          <mat-hint>This is used in the Automation's template</mat-hint>
        </mat-form-field>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="submit()"
    >
      Run Test {{ isMarketingContext ? 'Marketing Step' : 'Automation' }}
    </button>
  </mat-dialog-actions>
</form>
